import { render } from "./App.vue?vue&type=template&id=c978394e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c978394e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c978394e"]])

export default __exports__